import { useState, useEffect, useContext, useCallback } from "react";

//Context
import { AuthContext } from "../middlewares/Auth";

//Librerias
import axios from "axios";
import { toast } from "react-hot-toast";

/**
 * El hook devuelve las opciones de una lista dinámica almacenada en tbl_Listas,
 * filtrada por `strGrupo` y `strCodigo`.
 *
 * @param {{strGrupo: string, strCodigo: string, autoLoad: Boolean}} params
 * @returns {{data: Array, refreshGetData: Function}}
 */
const useGetListaDinamica = ({ strGrupo, strCodigo, autoLoad = true } = {}) => {
    const [data, setData] = useState();

    const { token } = useContext(AuthContext);

    const getData = useCallback(
        async (signalSubmitData) => {
            if (!strGrupo || !strCodigo) {
                setData([]);
                return;
            }

            setData(undefined);

            await axios(
                {
                    method: "GET",
                    baseURL: `${process.env.REACT_APP_PROTOCOL_BACKEND}://${process.env.REACT_APP_HOST_BACKEND}${process.env.REACT_APP_PORT_BACKEND}`,
                    url: `${process.env.REACT_APP_API_GETLISTA_DINAMICA}`,
                    params: {
                        strGrupo,
                        strCodigo,
                    },
                    headers: {
                        token,
                    },
                },
                {
                    cancelToken: signalSubmitData.token,
                }
            )
                .then((res) => {
                    if (res.data.error) {
                        toast.error(res.data.message);

                        setData({
                            error: true,
                            msg: res.data.message,
                        });

                        return;
                    }

                    setData(res.data.data || []);
                })
                .catch((error) => {
                    if (!axios.isCancel(error)) {
                        let msg;

                        if (error.response) {
                            msg = error.response.data.message;
                        } else if (error.request) {
                            msg = error.message;
                        } else {
                            msg = error.message;
                        }

                        toast.error(msg);

                        setData({
                            error: true,
                            msg,
                        });
                    }
                });
        },
        [token, strGrupo, strCodigo]
    );

    const refreshGetData = () => {
        let signalSubmitData = axios.CancelToken.source();

        setData();

        getData(signalSubmitData);
    };

    useEffect(() => {
        let signalSubmitData = axios.CancelToken.source();

        if (autoLoad) {
            getData(signalSubmitData);
        }

        return () => {
            signalSubmitData.cancel("Petición abortada.");
        };
    }, [getData, autoLoad]);

    return { data, refreshGetData };
};

export default useGetListaDinamica;
